export default "__VITE_ASSET__66e3e61f__"